import { vesselConstants } from '../../_constants';

export function vessels(state = {}, action) {
    switch (action.type) {
        case vesselConstants.VESSEL_FETCHING:
            return {
                ...state,
                vesselFetching: true
            };
        case vesselConstants.VESSEL_FETCHED:
            return {
                ...state,
                vesselFetching: false
            };
        case vesselConstants.VESSEL_SUBMITTING:
            return {
                ...state,
                vesselSubmitting: true
            };
        case vesselConstants.VESSEL_SUBMITTED:
            return {
                ...state,
                vesselSubmitting: false
            };
        case vesselConstants.GET_VESSELS:
            return {
                ...state,
                vessels: action.vessels,
            };
        case vesselConstants.GET_VESSEL_BY_ID:
            return {
                ...state,
                vessel: action.vessel
            };
        case vesselConstants.GET_VESSELSTOWAGETEMPLATE:
            return {
                ...state,
                vesselstowagetemple: action.vesselstowagetemple,
            };
        case vesselConstants.GET_VESSELSTOWAGETEMPLATE_BY_CODE:
            return {
                ...state,
                vesselstowagetemplecode: action.vesselstowagetemplecode
            };
        case vesselConstants.GET_VESSEL_FOR_CHANGE:
            return {
                ...state,
                vesselChangeReguide: action.vesselChangeReguide
            };
        case vesselConstants.GET_PROFIT_CENTER:
            return {
                ...state,
                PCData: action.PCData
            };
        default:
            return state;
    }
}